<template>
  <div class="raw-release-info">
    <!-- 硬盘释放为主卡（合并组共用） -->
    <raw-hdd-info
        v-if="hasHdd"
        :select-detail="selectDetail"
        @lookSampleInfo="lookSampleInfo">
      <!-- 链接释放入口：与硬盘释放同一行 -->
      <template v-if="linkRows.length" slot="operation">
        <span style="margin-right: 15px;margin-left:0px;color: #3f9dfe;cursor: pointer" @click="dialogVisible = true">（其中{{linkRows.length}}个项目有<span>链接释放</span><i v-html="viewDetailIcon()"></i>）</span>
      </template>
    </raw-hdd-info>
    <raw-link-info
        v-else
        :select-detail="selectDetail"
        @lookSampleInfo="lookSampleInfo">
    </raw-link-info>

    <!-- 释放详情弹框（独立组件，打开时重新请求，分 HDD/LINK） -->
    <raw-release-dialog
        :show-dialog.sync="dialogVisible"
        :select-detail="selectDetail">
    </raw-release-dialog>
  </div>
</template>

<script>
import RawHddInfo from './RawHddInfo.vue'
import RawLinkInfo from './RawLinkInfo.vue'
import RawReleaseDialog from './RawReleaseDialog.vue'
import {viewDetailIcon} from "@/utils/iconUtils";

export default {
  name: 'RawReleaseInfo',
  components: { RawHddInfo, RawLinkInfo, RawReleaseDialog },
  props: {
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    // 合并组里的项目列表
    projects() {
      return Array.isArray(this.selectDetail?.projectInfoList) ? this.selectDetail.projectInfoList : []
    },
    // 组级是否有硬盘释放
    hasHdd() {
      if (this.projects.length) return this.projects.some(p => this.projectTypes(p).includes('HDD'))
      return !!this.selectDetail?.isHdd
    },
    // 组内有链接释放的项目（弹框表格数据）
    linkRows() {
      return this.projects.filter(p => this.projectTypes(p).includes('ONLINE'))
    }
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    // 单个项目释放类型：releaseTypes 优先，兼容旧数据 isHdd
    projectTypes(p) {
      if (Array.isArray(p?.releaseTypes)) return p.releaseTypes
      return p?.isHdd ? ['HDD'] : ['ONLINE']
    },
    lookSampleInfo(row) {
      this.$emit('lookSampleInfo', row)
    }
  }
}
</script>

<style scoped>
.raw-release-info {
  font-size: 13px;
}
</style>
